/* eslint-disable no-unused-vars */
import { Outlet } from "react-router-dom";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Modal from "../components/Dashboard/Modal";
import axios from "axios";
import { BASEURL } from "../utilites";
import { IsLogin } from "../utilites/functions";
import { useEffect, useState } from "react";
import OnExitModalContent from "../components/forms/Modal/OnExitModal";
import { useLocation } from 'react-router-dom';



export default function FrontendLayout() {
  const [popupData, setPopupData] = useState({});
  const [hasShownPopup, setHasShownPopup] = useState(false);
  const location = useLocation();
  

  const getExitPopupData = async () => {
    try {
      const resp = await axios.get(`${BASEURL}/api/services/exit-popup`);
      if (resp?.data?.data) {
        setPopupData(resp.data.data);
      }
    } catch (error) {
      console.error("Error fetching exit popup data:", error);
    }
  };

  // useEffect(() => {
  //   if (!IsLogin()) {
  //     getExitPopupData();
  //   }
  // }, []);

  useEffect(() => {
    const handleMouseLeave = (e) => {
      const leftTop = e.clientY <= 0;
      const leftBottom = e.clientY >= window.innerHeight;

      if (
        (leftTop || leftBottom) &&
        Object.keys(popupData).length > 0 &&
        !IsLogin() &&
        !location?.pathname?.includes('book-appointment') &&
        !location?.pathname?.includes('thankyou') &&
        !hasShownPopup
      ) {
        document.querySelector(".onExitPopup")?.click();
        setHasShownPopup(true);
      }
    };

    document.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [popupData, hasShownPopup,location]);

  return (
    <div>
      <TopBar />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />

      <button
        className="onExitPopup d-none"
        data-bs-toggle="modal"
        data-bs-target="#openOnExitModal"
      ></button>

      {Object.keys(popupData).length > 0 && !IsLogin() && (
        <Modal
          title=""
          bodyClass="text-center text-dark text-opacity-50 border-0 p-0"
          centerClass="onExitModalStyles"
          btnText="Update"
          btnClass=""
          trigger="openOnExitModal"
          showBtn={false}
        >
          <OnExitModalContent popupData={popupData} />
        </Modal>
      )}
    </div>
  );
}
